
import { useEffect, useState } from 'react';
// Component Functions
import { Badge, Button, Divider, Menu, MenuButtonProps, MenuItem, MenuList, MenuPopover, MenuTrigger, Spinner, SplitButton, ToggleButton, Tooltip } from '@fluentui/react-components';
import * as ComponentFunctions from './ConsumptionList.Menu.Functions';

// Styles
import './ConsumptionList.Menu.Styles.css';
import { connect } from 'react-redux';
import { Add24Filled, AppsList20Filled, AppsList20Regular, ArrowSync20Regular, BranchFork20Filled, BranchFork20Regular, ClipboardArrowRight24Regular, ClipboardCheckmark24Regular, ClipboardClock24Regular, EyeOff20Regular, Payment24Regular, PeopleTeam20Filled, PeopleTeam20Regular } from '@fluentui/react-icons';
import ConsumptionFormComponent from '../../ConsumptionForm/Consumption.Form.Component';
import { ExportToExcelLink } from '../../../ExportToExcel/ExportToExcelLink.Component';

/*
    status
    -----------------------------
    NotSettled = 0,
    Pending = 1,
    Payee = 2,
    Settled = 3,
    Rejected = 4,
    Ignored = 5,
    ToSettle = 6
 */


const ConsumptionListMenuComponent = (props: ComponentFunctions.Props) => {

    // create or edit form
    const [isConsumptionFormOpen, setIsConsumptionFormOpen] = useState(false);
    const [enableVisitGrouping, setEnableVisitGrouping] = useState(true);

    useEffect(() => {
        props.onChangeAgroupation(enableVisitGrouping);
    }, [enableVisitGrouping]);


    const onReloadConsumptions = () => {
        props.onRequestUpdate();
    }

    const onConsumptionFormDismiss = () => {
        setIsConsumptionFormOpen(false);
    }

    const onCLickMarkAsPaid = () => {
        props.SelectedConsumptions.forEach(element => {
            props.ChangeStatus(props.ProtocolId, element.id, 2, false);
        });
    };

    const onCLickMarkToSettled = () => {
        props.SelectedConsumptions.forEach(element => {
            props.ChangeStatus(props.ProtocolId, element.id, 6, false);
        });
    };

    const onClickMarkAsRejected = () => {
        props.SelectedConsumptions.forEach(element => {
            props.ChangeStatus(props.ProtocolId, element.id, 4, false);
        });
    }

    const onClickMarkAsPending = () => {
        props.SelectedConsumptions.forEach(element => {
            props.ChangeStatus(props.ProtocolId, element.id, 0, false);
        });
    }

    const onClickMarkAsIgnored = () => {
        props.SelectedConsumptions.forEach(element => {
            props.ChangeStatus(props.ProtocolId, element.id, 5, false);
        });
    }

    const Forms = (
        <>
            {props.ProtocolId && <ConsumptionFormComponent
                ProtocolId={props.ProtocolId}
                isOpen={isConsumptionFormOpen}
                onClose={onConsumptionFormDismiss}
            />}
        </>
    );

    const ChangeStatusToolbar = () => {

        const onClick = () => onCLickMarkToSettled();

        const primaryActionButtonProps = {
            onClick,
        };

        return (
            <Menu positioning="below-end">
                <MenuTrigger disableButtonEnhancement>
                    {(triggerProps: MenuButtonProps) => (
                        <SplitButton
                            menuButton={triggerProps}
                            primaryActionButton={primaryActionButtonProps}
                            disabled={props.SelectedConsumptions?.length === 0}
                            appearance='secondary'      
                            icon={props.isChangingStatus ? <Spinner size="extra-tiny" /> : <ClipboardCheckmark24Regular />}                        
                        >
                            A liquidar&nbsp;{props.SelectedConsumptions?.length > 0 && <Badge size='small' appearance="filled">{props.SelectedConsumptions?.length}</Badge>}
                        </SplitButton>
                    )}
                </MenuTrigger>

                <MenuPopover>
                    <MenuList>
                        <MenuItem onClick={onCLickMarkAsPaid} icon={<Payment24Regular/>}>Cobrado</MenuItem>
                        <MenuItem onClick={onClickMarkAsRejected} icon={<ClipboardArrowRight24Regular/>}>Rechazado</MenuItem>
                        <MenuItem onClick={onClickMarkAsPending} icon={<ClipboardClock24Regular/>}>Pendiente</MenuItem>
                        <MenuItem onClick={onClickMarkAsIgnored} icon={<EyeOff20Regular />}>Ignorado</MenuItem>                        
                    </MenuList>
                </MenuPopover>
            </Menu>
        )
    }

    return (
        <div className='menuContainer'>
            <label>{props.Filters?.SelectedDateRange[0]?.toDateString()}</label>
            <Button appearance='primary' icon={props.isAddingConsumption ? <Spinner size="extra-tiny" /> : <Add24Filled />} onClick={() => setIsConsumptionFormOpen(true)}>Agregar Concepto</Button>
            <Button appearance='secondary' onClick={onReloadConsumptions}><ArrowSync20Regular /></Button>
            {props.showGrouping && <>
                <Divider vertical={true} />
                <Tooltip content="Ver conceptos agrupados por visita" relationship="label" {...props}>
                    <ToggleButton
                        checked={enableVisitGrouping}
                        icon={enableVisitGrouping ? <BranchFork20Filled style={{transform: 'rotate(90deg)'}} /> : <BranchFork20Regular style={{transform: 'rotate(90deg)'}} />}
                        onClick={() => setEnableVisitGrouping(true)}
                    >
                    </ToggleButton>
                </Tooltip>
                <Tooltip content="Ver listado de conceptos sin agrupar" relationship="label" {...props}>
                    <ToggleButton
                        checked={enableVisitGrouping === false}
                        icon={enableVisitGrouping === false ? <AppsList20Filled /> : <AppsList20Regular />}
                        iconPosition="after"
                        onClick={() => setEnableVisitGrouping(false)}
                    >
                    </ToggleButton>
                </Tooltip>
            </>}
            <Divider vertical={true} />
            <ChangeStatusToolbar />
            {/* <Button disabled={props.SelectedConsumptions?.length === 0} appearance='secondary' icon={props.isChangingStatus ? <Spinner size="extra-tiny" /> : <Payment24Regular />} onClick={onCLickMarkAsPaid}>Cobrado&nbsp;{props.SelectedConsumptions?.length > 0 && <Badge size='small' appearance="filled">{props.SelectedConsumptions?.length}</Badge>}</Button>
            <Button disabled={props.SelectedConsumptions?.length === 0} appearance='secondary' icon={props.isChangingStatus ? <Spinner size="extra-tiny" /> : <ClipboardCheckmark24Regular />} onClick={onCLickMarkToSettled}>A liquidar&nbsp;{props.SelectedConsumptions?.length > 0 && <Badge size='small' appearance="filled">{props.SelectedConsumptions?.length}</Badge>}</Button>
            <Button disabled={props.SelectedConsumptions?.length === 0} appearance='secondary' icon={props.isChangingStatus ? <Spinner size="extra-tiny" /> : <ClipboardArrowRight24Regular />} onClick={onClickMarkAsRejected}>Rechazar&nbsp;{props.SelectedConsumptions?.length > 0 && <Badge size='small' appearance="filled">{props.SelectedConsumptions?.length}</Badge>}</Button>
            <Button disabled={props.SelectedConsumptions?.length === 0} appearance='secondary' icon={props.isChangingStatus ? <Spinner size="extra-tiny" /> : <ClipboardClock24Regular />} onClick={onClickMarkAsPending}>Pendiente&nbsp;{props.SelectedConsumptions?.length > 0 && <Badge size='small' appearance="filled">{props.SelectedConsumptions?.length}</Badge>}</Button>
            <Button disabled={props.SelectedConsumptions?.length === 0} appearance='secondary' icon={props.isChangingStatus ? <Spinner size="extra-tiny" /> : <MdOutlineHideImage />} onClick={onClickMarkAsIgnored}>Ignorar&nbsp;{props.SelectedConsumptions?.length > 0 && <Badge size='small' appearance="filled">{props.SelectedConsumptions?.length}</Badge>}</Button> */}
            <Divider vertical={true} />
            <ExportToExcelLink Filters={props.Filters} entityId={props.ProtocolId.toString()} Type='Protocol' />
            <Divider vertical={true} />
            <Tooltip content="Ver consumos por paciente" relationship="label" {...props}>
                <ToggleButton
                    checked={props.showByPatient}
                    icon={props.showByPatient ? <PeopleTeam20Filled /> : <PeopleTeam20Regular />}
                    onClick={() => props.onTogglePatientView(!props.showByPatient)}
                />
            </Tooltip>
            {Forms}
        </div>
    );
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ConsumptionListMenuComponent as any);